<template>
  <transition name="fade">
    <b-card no-body class="w-100">
      <div slot="header" class="header">
        <div>{{ title }} (loaded: {{ totalItems }})</div>
        <div class="card-header-actions">
          <div v-if="totalItems && exportTypes && csvAccess">
            <b-button
              v-for="(exportType, index) in exportTypes"
              @click="$emit('export', exportType)"
              :key="`type-${index}`"
              variant="primary"
              size="sm"
              class="download-button">
              {{ exportType.toUpperCase() }}
            </b-button>
          </div>
        </div>
      </div>

      <b-card-body class="card-content">
        <c-table
          class="h-100"
          :table-data="itemsFormatted"
          :fields="columns"
          :sorting="sorting"
          :striped="true"
          :bordered="false"
          :small="false"
          :perPage="10"
          :current-page-external="currentPage"
          @page-changed="pageChanged"
          caption="">
        </c-table>
      </b-card-body>
    </b-card>
  </transition>
</template>

<script>
import cTable from '../Table.vue'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'port-calls-table',
  components: {
    cTable
  },
  props: {
    title: {
      type: String,
      default: 'Port calls',
    },

    items: {
      type: Array,
      default: () => []
    },

    currentPage: {
      type: Number,
      default: () => 1
    },

    sorting: {
      type: Boolean,
      default: false,
    },

    exportTypes: {
      type: Array,
      default: () => null
    }
  },

  data() {
    return {
      columns: [
        { key: 'IMO', sortable: true },
        { key: 'vesselName', sortable: true },
        { key: 'portName', sortable: true },
        { key: 'countryCode', sortable: true },
        { key: 'berthName', sortable: true },
        { key: 'anchorageName', sortable: true },
        { key: 'arrivedAt', sortable: true },
        { key: 'berthedAt', sortable: true },
        { key: 'departedAt', sortable: true },
        { key: 'daysInPort', sortable: true },
        { key: 'daysWaiting', sortable: true },
        { key: 'daysAtBerth', sortable: true },
        { key: 'operation', sortable: true },
      ],
      csvAccess: false
    };
  },

  async mounted() {
    await this.getUserData();
  },

  methods: {
    ...mapActions('api', ['getUser']),

    async getUserData() {
      let user = await this.getUser();
      this.csvAccess =
        user[
          'https://app.oceanbolt.com/user_authorization'
        ].permissions.includes('download:csv') || false;
    },

    pageChanged(currentPage, totalPages) {
      // we have to emit 2 events since we have 3 level in components: TradeFlows -> Voyages -> Table
      // data came from 'Tradeflows' so current/total page must be available there
      this.$emit('page-changed', currentPage, totalPages);
    }
  },
  computed: {
    itemsFormatted() {
      return this.items.map(item => {
        let formattedItem = {};
        this.columns.forEach(field => {
          if (field.key === 'IMO') {
            formattedItem[field.key] = item['imo'];
          } else if (field.key === 'arrivedAt' || field.key === 'berthedAt' || field.key === 'departedAt') {
            formattedItem[field.key] = item[field.key] ? moment(item[field.key]).format("YYYY-MM-DD @ HH:mm") : "-";
          } else {
            formattedItem[field.key] = item[field.key];
          }
        });
        formattedItem.totalTimeInPort = Math.round(formattedItem.totalTimeInPort * 10 / 24) / 10;
        return formattedItem;
      });
    },

    totalItems() {
      return this.items.length;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card-header-actions {
    display: flex;
  }
}
</style>
